// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f075ea61","239":"3f0e456a","732":"f844637f"}[chunkId] + ".chunk.js";
};